export default __webpack_public_path__ + "static/media/cart-cancelled.a8bc32e3.svg";